import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import StatusField from 'components/field/StatusField';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import { deleteWebhook } from 'store/actions/webhooks/deleteWebhooks';
import { fetchWebhooks } from 'store/actions/webhooks/fetchWebhooks';

class WebhooksList extends React.Component {
    render() {
        const {
            actionType,
            location,
            resource,
        } = this.props;

        return (
            <div>
                <ResourceList
                    action={ fetchWebhooks }
                    actionType={ actionType }
                    location={ location }
                    resource={ resource }
                >
                    <Table
                        triggerInformationModal={ false }
                    >
                        <TextField
                            column={ {
                                link: false,
                                sortable: false,
                                width: '20%',
                            } }
                            label='resources.webhooks.fields.name'
                            source='name'
                        />

                        <TextField
                            column={ {
                                link: false,
                                sortable: false,
                            } }
                            label='resources.webhooks.fields.url'
                            maxCharacters={ 100 }
                            source='url'
                        />

                        <StatusField
                            column={ {
                                align: 'center',
                                link: false,
                                sortable: false,
                                width: '10%',
                            } }
                            label='resources.webhooks.fields.is_active'
                            source='is_active'
                        />

                        <DropDownActionsMenu
                            column={ {
                                align: 'center',
                                link: false,
                                width: '10%',
                            } }
                            resource={ resource }
                        >
                            <EditAction />

                            <DeleteAction action={ deleteWebhook } />
                        </DropDownActionsMenu>
                    </Table>
                </ResourceList>
            </div>
        );
    }
}

WebhooksList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
};

export default WebhooksList;



// WEBPACK FOOTER //
// ./src/pages/webhooks/list/WebhooksList.js